import React, { useState, useEffect, useRef } from "react";
import { useNavigate, useParams } from 'react-router-dom';
import { onAttributeList, onAttributeChoiceList } from "../../controller/CategoryController";
import { onBrand, onAddAttributeChoiceToBrand, onBrandSubmit } from "../../controller/BrandController";
import 'react-toastify/dist/ReactToastify.css';
import toast, { Toaster } from 'react-hot-toast';
import AuthUtility from "../../util/AuthUtility";
import { Col, Button, Row, Container, Card, Form, Table, 
  Tabs, Tab, Modal } from 'react-bootstrap';
import { FileModel } from "../../dto/FileModel";
import Delete from '@mui/icons-material/Delete';
import { AttributeEntity } from "../../dto/attribute/AttributeEntity";
import { BrandEntity } from "../../dto/brand/BrandEntity";
import { BrandModel } from "../../dto/brand/BrandModel";
import Select from 'react-select';
import { AttributeChoiceEntity } from "../../dto/attribute/AttributeChoiceEntity";

type BrandParams = {
    brandId: string;
};

const BrandDetail = () => {
  const urlParam = useParams<BrandParams>();
  const [key, setKey] = useState('attributeTab');
  const addAttributeChoiceForm = useRef<HTMLFormElement>(null);

  const handleReset = (form: string) => {
    if (form === 'addAttributeChoiceForm') {
        if (addAttributeChoiceForm.current !== null) {
            addAttributeChoiceForm.current.reset();
        }
    }
  };

  const fileRef = useRef<HTMLInputElement>(null);

  // BRAND PHOTO
  const [brandPhoto, setBrandPhoto] = useState<FileModel>({
    id: undefined,
    data: undefined
  });

  // BRAND
  const brandEntity: BrandEntity = {
  }
  const [brand, setBrand] = useState<BrandModel>({
    action: 'update',
    entity: brandEntity
  });

  // BRAND LINKED ATTRIBUTES
  const [linkedAttributeChoices, setLinkedAttributeChoices] = useState<Array<AttributeChoiceEntity>>([]);

  // New attribute choice modal
  const [newAttributeChoiceModalShow, setNewAttributeChoiceModalShow] = useState(false);
  const handleNewAttributeChoiceModalClose = () => setNewAttributeChoiceModalShow(false);

  const [attributeChoiceOptions, setAttributeChoiceOptions] = useState<Array<Object>>([]);

  const navigate = useNavigate();

  // first render
  useEffect(() => {
    if (!AuthUtility.isUserLoggedIn()) {
        navigate("/login");
        window.location.reload();
    } else {
        brandDetailGet();
        attributeListGet();
        // attributeChoiceListGet();
    }
  }, [])

  // attribute choice update
  const brandDetailGet = async () => {
    const brandResponse = await onBrand(urlParam.brandId || "");
    if (brandResponse.status === 0) {
      if (brandResponse.data.totalElements > 0) {
        // category
        const current: BrandEntity = brandResponse.data.beans[0];
        setBrand({
          ...brand,
          entity: current
        });
        const brandLinkedAttributeChoices = await onAttributeChoiceList(undefined, undefined, undefined, current.id);
        if (brandLinkedAttributeChoices.status === 0) {
          // linked attributes
          const linkedAttributeChoices: Array<AttributeChoiceEntity> = brandLinkedAttributeChoices.data.beans;
          for (var i = 0; i < linkedAttributeChoices.length; i++) {
            var bean: AttributeChoiceEntity = linkedAttributeChoices[i];
            var attributeList = await onAttributeList(undefined, bean.attributeId);
            if (attributeList.data.totalElements > 0) {
                var attribute: AttributeEntity = attributeList.data.beans[0];
                bean.attrbtName = attribute.name;
            }
          }
          setLinkedAttributeChoices(linkedAttributeChoices);
        }
      } else {
        // NO DETAIL
      }
    }
  }

  // get attribute choices list
  const attributeChoiceListGet = async () => {
    const attributeChoiceList = await onAttributeChoiceList();
    const tmp: Array<AttributeChoiceEntity> = [];
    for (var i = 0; i < attributeChoiceList.data.beans.length; i++) {
        var bean: AttributeChoiceEntity = attributeChoiceList.data.beans[i];
        var attributeList = await onAttributeList(undefined, bean.attributeId);
        if (attributeList.data.totalElements > 0) {
            var attribute: AttributeEntity = attributeList.data.beans[0];
            bean.attrbtName = attribute.name;
        }
        tmp.push(bean);
    }

    const optionArray: Array<Object> = [];
    tmp.map((item, index) => {
        var obj = {
            value: item.id + "-" + item.attributeId,
            label: item.attrbtName + " - " + item.valueText
        }
        optionArray.push(obj);
    })
    setAttributeChoiceOptions(optionArray);
  }

  // ATTRIBUTE LIST
  const [attributeOptions, setAttributeOptions] = useState<Array<Object>>([]);

  const attributeListGet = async () => {
    const attributeList = await onAttributeList();
    const tmp: Array<AttributeEntity> = attributeList.data.beans;

    const optionArray: Array<Object> = [];
    for (var i = 0; i < tmp.length; i++) {
      var bean: AttributeEntity = tmp[i];
      var obj = {
        value: bean.id,
        label: bean.name
      }
      optionArray.push(obj);
    }
    setAttributeOptions(optionArray);
  }

  // category update
  const brandUpdateSubmit = async (event: React.FormEvent) => {
    event.preventDefault();
    const form = event.currentTarget as HTMLFormElement;
    if (form.checkValidity() === false) {
      event.stopPropagation();
    } else {
        // action
        try {
          // const response = await onBrandSubmit(brand, brandPhoto);
          // if (response !== undefined) {
          //   if (response.status === 0) {
          //       toast.success(response.msg);
          //       brandDetailGet();
          //   } else {
          //       toast.error(response.msg);
          //   }
          // }
      } catch(e: any) {
          console.log(e);
          toast.error("Амжилтгүй");
      }
      if (fileRef.current !== null) {
        fileRef.current.value = "";
      }
    }
  }

  // BRAND ADD ATTRIBUTE CHOICE
  // const addAttributeChoiceEntity: BrandEntity = {
  //   id: undefined,
  //   logo: undefined,
  //   ordr: undefined,
  //   name: '',
  //   logo_og: '',
  //   logo_md: '',
  //   logo_sm: '',
  //   logo_lg: '',
  //   attributeChoiceId: undefined,
  //   attributeId: undefined
  // }
  // const [addAttributeChoice, setAddAttributeChoice] = useState<BrandModel>({
  //   action: 'add-attribute-choice',
  //   entity: addAttributeChoiceEntity
  // });
  const [addAttributeChoiceList, setAddAttributeChoiceList] = useState<Array<BrandEntity>>([])

  // brand attribute choice create
  const addAttributeChoiceToBrand = async (event: React.FormEvent) => {
    event.preventDefault();
    const form = event.currentTarget as HTMLFormElement;
    console.log(form.checkValidity());
    if (form.checkValidity() === false) {
      event.stopPropagation();
    } else {
      // action
      if (addAttributeChoiceList.length > 0) {
        for (var i = 0; i < addAttributeChoiceList.length; i++) {
          var addAttributeChoice: BrandModel = {
            action: 'add-attribute-choice',
            entity: addAttributeChoiceList[i]
          };
          const response = await onAddAttributeChoiceToBrand(addAttributeChoice);
          if (i == addAttributeChoiceList.length - 1) {
            if (response !== undefined) {
              if (response.status === 0) {
                  toast.success(response.msg);
                  handleReset('addAttributeChoiceForm');
                  handleNewAttributeChoiceModalClose();
                  brandDetailGet();
              } else {
                  toast.error(response.msg);
                  let err = Object.entries(response.errors)
                  err.map( ([key, val]) => {
                    toast.error(key + ": " + val);
                  });
              }
            }
          }
        }
      } else {
        toast.error("СОНГОЛТ хоосон байна.")
      }
    }
  }

  // ATTRIBUTE CHOICE SELECT BOX
  const attributeChoicePicker = (selectedOption: Object) => {
    var attributeIds: Array<string> = Array.isArray(selectedOption) ? selectedOption.map(x => x.value) : [];
    if (attributeIds.length > 0) {
      var choiceList: Array<BrandEntity> = [];
      for (var i = 0; i < attributeIds.length; i++) {
        var attrObject = attributeIds[i].split("-");
        if (attrObject.length > 1) {
          var choiceEntity: BrandEntity = {};
          choiceEntity.id = parseInt(urlParam.brandId!);
          choiceList.push(choiceEntity);
        }
      }
      setAddAttributeChoiceList(choiceList);
    }
  }

  // ATTRIBUTE SELECT BOX
  const attributePicker = async (selectedOption: any) => {
    const attributeChoiceList = await onAttributeChoiceList(undefined, selectedOption.value);
    const tmp: Array<AttributeChoiceEntity> = [];
    for (var i = 0; i < attributeChoiceList.data.beans.length; i++) {
        var bean: AttributeChoiceEntity = attributeChoiceList.data.beans[i];
        var attributeList = await onAttributeList(undefined, bean.attributeId);
        if (attributeList.data.totalElements > 0) {
            var attribute: AttributeEntity = attributeList.data.beans[0];
            bean.attrbtName = attribute.name;
        }
        tmp.push(bean);
    }

    const optionArray: Array<Object> = [];
    tmp.map((item, index) => {
        var obj = {
            value: item.id + "-" + item.attributeId,
            label: item.attrbtName + " - " + item.valueText
        }
        optionArray.push(obj);
    })
    setAttributeChoiceOptions(optionArray);
  }

  // BRAND REMOVE ATTRIBUTE CHOICE
  const removeAttributeChoiceEntity: BrandEntity = {
  }
  const [removeAttributeChoice, setRemoveAttributeChoice] = useState<BrandModel>({
    action: 'remove-attribute-choice',
    entity: removeAttributeChoiceEntity
  });

  // ATTRIBUTE CHOICE REMOVE FROM BRAND
  const removeAttributeChoiceFromBrand = (brandId: number, choiceId: number, attributeId: number) => {
    if (window.confirm("Are you sure?")) {
        const prevState = {...removeAttributeChoice.entity};
        prevState.id = brandId;
        setRemoveAttributeChoice({
            ...removeAttributeChoice,
            entity: prevState
        })
      }
  }

  const removeAttributeChoiceFromBrandSubmit = async () => {
    // action
    // const response = await onRemoveAttributeChoiceFromBrandSubmit(removeAttributeChoice);
    // if (response !== undefined) {
    //   if (response.status === 0) {
    //       toast.success(response.msg);
    //       brandDetailGet();
    //   } else {
    //       toast.error(response.msg);
    //       let err = Object.entries(response.errors)
    //       err.map( ([key, val]) => {
    //         toast.error(key + ": " + val);
    //       });
    //   }
    // }
  }

  return (
    <Container fluid>
      <div><Toaster position="top-right" reverseOrder={false}/></div>
      <h3><a onClick={() => navigate(-1)}><big>&#8592;</big></a>Брэнд</h3>
      <Row className="d-flex justify-content-center align-items-center mb-3">
        <Col md={12} lg={12} xs={12}>
          <Card>
            <Card.Header>
                <h5>Ерөнхий мэдээлэл</h5>
            </Card.Header>
            <Card.Body>
              <Row>
                <Col md={9} lg={9} xs={9}>
                  <Form onSubmit={brandUpdateSubmit}>
                    <Row>
                      <Col md={4}>
                        <Form.Group className="mb-3" controlId="categoryName">
                            <Form.Label className="text-center">Нэр</Form.Label>
                            <Form.Control type="text" size="sm" value={brand.entity.name || ""}
                            onChange={(event) => {
                              const prevState: BrandEntity = {...brand.entity};
                              prevState.name = event.target.value;
                              setBrand({
                                  ...brand,
                                  entity: prevState
                              })
                            }}/>
                        </Form.Group>
                      </Col>
                      <Col md={3}>
                        <Form.Group className="mb-3" controlId="categoryOrder">
                            <Form.Label className="text-center">Эрэмбэ</Form.Label>
                            <Form.Control type="text" size="sm"
                            onChange={(event) => {
                              const prevState: BrandEntity = {...brand.entity};
                              prevState.sortOrder = parseInt(event.target.value);
                              setBrand({
                                  ...brand,
                                  entity: prevState
                              })
                            }}/>
                        </Form.Group>
                      </Col>
                    </Row>
                    <Row>
                      <Col md={4}>
                        <Form.Group controlId="categoryFile" className="mb-3">
                          <Form.Label>ЗУРАГ</Form.Label>
                          <Form.Control ref={fileRef} type="file" size="sm" accept="image/*" 
                          onChange = {(event: React.ChangeEvent<HTMLInputElement>) => setBrandPhoto({
                            ...brandPhoto,
                            data: event.target.files ? event.target.files.item(0) : null
                        })}/>
                        </Form.Group>
                      </Col>
                    </Row>
                    <Row>
                      <Col md={3}>
                          <Form.Group className="mb-3">
                            <Button variant="primary" type="submit" size="sm">
                              Хадгалах
                            </Button>
                          </Form.Group>
                      </Col>
                    </Row>
                  </Form>
                </Col>
              </Row>
            </Card.Body>
            <Card.Footer>
            <Tabs
              id="controlled-tab-example"
              activeKey={key}
              onSelect={(k) => {
                if (k != null) {
                  setKey(k)
                }
              }}
              className="mb-3">
              {/* ATTRIBUTE CHOICE TAB */}
              <Tab eventKey="attributeTab" title="Attribute Choice">
                <Row>
                  <Col md={12} lg={12} xs={12}>
                    <Button variant="outline-primary" 
                    size="sm" 
                    onClick={() => {
                      // const prevState: BrandEntity = {...addAttributeChoice.entity};
                      // prevState.id = parseInt(urlParam.brandId!);
                      // setAddAttributeChoice({
                      //     ...addAttributeChoice,
                      //     entity: prevState
                      // })
                      setNewAttributeChoiceModalShow(true);
                    }}>
                      Атрибут утга нэмэх
                    </Button>
                    <Table hover bordered>
                      <thead>
                        <tr>
                          <th>Атрибут</th>
                          <th>Утга</th>
                          <th><Delete /></th>
                        </tr>
                      </thead>
                      <tbody>
                          {
                            linkedAttributeChoices.map((attrbtChoice, attrbtIdx) => {
                              return (
                                <tr key={attrbtIdx}>
                                    <td>{attrbtChoice.attrbtName}</td>
                                    <td>{attrbtChoice.valueText}</td>
                                    <td>
                                        <span>
                                        <a style={{ float: "left" }} 
                                            onClick={() => removeAttributeChoiceFromBrand(parseInt(urlParam.brandId!), parseInt(`${attrbtChoice.id}`), parseInt(`${attrbtChoice.attributeId}`))}>
                                            <Delete />
                                        </a>
                                        </span>
                                    </td>
                                </tr>
                              )
                            })
                          }
                      </tbody>
                    </Table>
                  </Col>
                </Row>
              </Tab>
            </Tabs>
            </Card.Footer>
          </Card>
        </Col>
      </Row>
      {/* NEW ATTRIBUTE CHOICE */}
      <Modal show={newAttributeChoiceModalShow} onHide={handleNewAttributeChoiceModalClose}>
        <Modal.Header closeButton>
          <Modal.Title>Атрибут утга нэмэх</Modal.Title>
        </Modal.Header>
        <Form onSubmit={addAttributeChoiceToBrand}
        ref={addAttributeChoiceForm}>
          <Modal.Body>
            <Row className="mb-3">
              <Col sm={12} md={12} lg={12}>
                <Form.Group controlId="attributes">
                  <Form.Label>АТРИБУТ</Form.Label>
                  <Select
                    options={attributeOptions}
                    onChange={attributePicker}
                    isMulti={false}
                    isClearable={true}
                    isSearchable={true}
                    isDisabled={false}
                    isLoading={false}
                    isRtl={false}
                    />
                </Form.Group>
              </Col>
            </Row>
            <Row>
              <Col sm={12} md={12} lg={12}>
                <Form.Group controlId="attributeChoices">
                  <Form.Label>СОНГОЛТ</Form.Label>
                  <Select
                    options={attributeChoiceOptions}
                    onChange={attributeChoicePicker}
                    isMulti={true}
                    isClearable={true}
                    isSearchable={true}
                    isDisabled={false}
                    isLoading={false}
                    isRtl={false}
                    />
                </Form.Group>
              </Col>
            </Row>
          </Modal.Body>
          <Modal.Footer>
            <Button variant="secondary" onClick={handleNewAttributeChoiceModalClose}>
              Хаах
            </Button>
            <Button variant="primary" type="submit" size="sm">
              Хадгалах
            </Button>
          </Modal.Footer>
        </Form>
      </Modal>
    </Container>
  )
}

export default BrandDetail;